// removed by extract-text-webpack-plugin
module.exports = {"wineProfile":"_2O_0v","photo":"oQ5Zy","details":"_2spKB","name":"_3VOPx","ratingAndPriceRow":"_1JxFe","bullet":"_2rqrP","priceRange":"_2abUx","offers":"_3t6tL","reviews":"_1cZEK","offerSectionTitle":"_2Cnp9","offer":"_2Uw5J","header":"E57MG","store":"_1qWsP","location":"_1bWCd","promotions":"aH7M3","price":"_3SW6j","actions":"_2rVGT","shopLink":"_25Hm7","separator":"_3119X"};


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/WineSkuContainer/index.sass
// module id = 1528
// module chunks = 1